import * as React from "react";
const SvgInventory = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M7 9V12H33V9H7ZM6 6H34C35.0625 6 36 6.9375 36 8V13C36 14.125 35.0625 15 34 15H6C4.875 15 4 14.125 4 13V8C4 6.9375 4.875 6 6 6ZM14 19.5C14 18.6875 14.625 18 15.5 18H24.5C25.3125 18 26 18.6875 26 19.5C26 20.375 25.3125 21 24.5 21H15.5C14.625 21 14 20.375 14 19.5ZM6 30V17H9V30C9 30.5625 9.4375 31 10 31H30C30.5 31 31 30.5625 31 30V17H34V30C34 32.25 32.1875 34 30 34H10C7.75 34 6 32.25 6 30Z" }));
export default SvgInventory;
